<template>
<div
        class="file-share-avatar-content"
        ref="content"
        v-if="showtype !== 'sdk'"
    >
        <div class="file-avatar-img">
            <div
                v-if="type === 'PERSON' && fileAvatar === ''"
                class="user-avatar"
                :style="avatarColorStye"
            >
                <div class="user-name">{{ userName }}</div>
            </div>
            <img v-else :src="fileAvatar" style="object-fit: cover" />
        </div>
        <div class="file-avatar-name">{{ name }}</div>
    </div>
</template>

<script lang="ts">
import nameColor from '../../utils/nameColor';
import memberAvatar from '../../utils/avatar';
import DepartmentAvatar from '../../assets/img/share/icon_file_file.png';
import { mapState } from 'vuex';
export default {
    name: 'FileShareAvatar',
    props: {
        avatar: {
            type: String,
            default: ''
        },
        name: {
            type: String,
            default: ''
        },
        type: {
            type: String
        }
    },
    data() {
        return {};
    },
    computed: {
        ...mapState({
            showtype: (state: any) => state.kbModule.showtype
        }),
        fileAvatar() {
            if (this.type === 'PERSON') {
                const userAvatar = memberAvatar.getMemberAvatar(
                    this.avatar,
                    ''
                );
                return (
                    userAvatar['100'] ??
                    userAvatar['300'] ??
                    userAvatar['original']
                );
            } else {
                return DepartmentAvatar;
            }
        },
        avatarColorStye() {
            if (!this.name) {
                return 'background-color: #5C70FF;';
            }
            let avatarColor = nameColor.getNameColor(this.name);
            return `background-color: ${avatarColor}`;
        },
        userName() {
            if (!this.name) {
                return '';
            }
            return nameColor.getLastName(this.name);
        }
    },
    mounted() {},
    methods: {}
};
</script>

<style lang="scss" scope="true">
.file-share-avatar-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: 40px;
    background: #f4f6f9;
    border-radius: 8px;

    .file-avatar-img {
        width: 32px;
        height: 32px;
        border-radius: 4px;
        margin-left: 4px;
        margin-right: 8px;

        img {
            width: 32px;
            height: 32px;
            border-radius: 4px;
        }

        .user-avatar {
            width: 32px;
            height: 32px;
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;

            .user-name {
                font-family: PingFangSC-Regular;
                font-weight: 300;
                font-size: 12px;
                color: #ffffff;
                letter-spacing: 0;
                line-height: 17px;
            }
        }
    }

    .file-avatar-name {
        font-family: PingFangSC-Regular;
        font-weight: 300;
        font-size: 14px;
        color: #323233;
        letter-spacing: 0;
        margin-right: 8px;
        white-space: nowrap;
    }
}
</style>
